import { useQuery } from "@tanstack/react-query"
import type { SmsLogFilter } from "@/api"
import { api } from "@/api"

export const smsKeys = {
  health: ["sms", "health"] as const,
  log: (filter: SmsLogFilter) => ["sms", "log", filter] as const,
}

/**
 * Состояние SMS-канала. Баланс СМСЦ живёт своей жизнью (его тратят коды входа),
 * поэтому обновляем раз в минуту — иначе администратор смотрит на цифру,
 * которая устарела ещё до того, как он открыл страницу.
 */
export function useSmsHealth() {
  return useQuery({
    queryKey: smsKeys.health,
    queryFn: () => api.sms.health(),
    refetchInterval: 60_000,
  })
}

export function useSmsLog(filter: SmsLogFilter) {
  return useQuery({
    queryKey: smsKeys.log(filter),
    queryFn: () => api.sms.log(filter),
  })
}
